import { get } from 'lodash';

import { FIELD_PATHS, RELATED_PARTY_QUESTIONS } from '@funnels/constants';
import { useFormValues } from '@funnels/hooks';
import { PostProductSelectContract } from '@funnels/types';
import { SummaryStringDisplay } from '@funnels/ui-components';
import { Accordion, FunnelGrid, FunnelGridUnit } from '@funnels/ui-components/Common';
import { capitalizeForEnumValue } from '@funnels/utils';

interface AccountantSummaryProps {
  relatedPartyIndex: number;
  accountantSelect: PostProductSelectContract;
  handleEditClick?: () => void;
}

export const AccountantSummary = ({ relatedPartyIndex, handleEditClick, accountantSelect }: AccountantSummaryProps) => {
  const [formValues] = useFormValues();
  const questions = get({ postProductSelect: [accountantSelect] }, FIELD_PATHS.POST_PRODUCT_SELECT_QUESTIONS(0));

  const hasNameSection =
    questions.includes(RELATED_PARTY_QUESTIONS.TITLE) ||
    questions.includes(RELATED_PARTY_QUESTIONS.FIRST_NAME) ||
    questions.includes(RELATED_PARTY_QUESTIONS.LAST_NAME);
  const name = `${capitalizeForEnumValue(
    get(formValues, FIELD_PATHS.RELATED_PARTY_TITLE(relatedPartyIndex), '')
  )}  ${get(formValues, FIELD_PATHS.RELATED_PARTY_FIRST_NAME(relatedPartyIndex), '')} ${get(
    formValues,
    FIELD_PATHS.RELATED_PARTY_LAST_NAME(relatedPartyIndex),
    ''
  )}`;

  return (
    <Accordion headerText="Accountant details" onPrimaryButtonClick={handleEditClick} primaryButtonLabel="Edit">
      <FunnelGrid>
        {hasNameSection && (
          <FunnelGridUnit my="xs" size={1 / 2}>
            <SummaryStringDisplay title="Name" value={name} />
          </FunnelGridUnit>
        )}
        {questions.includes(RELATED_PARTY_QUESTIONS.PHONE) && (
          <FunnelGridUnit my="xs" size={1 / 2}>
            <SummaryStringDisplay
              title="Phone number"
              value={get(formValues, FIELD_PATHS.RELATED_PARTY_PHONE(relatedPartyIndex))}
            />
          </FunnelGridUnit>
        )}
        {questions.includes(RELATED_PARTY_QUESTIONS.BUSINESS_NAME) && (
          <FunnelGridUnit my="xs" size={1 / 2}>
            <SummaryStringDisplay
              title="Business name"
              value={get(formValues, FIELD_PATHS.RELATED_PARTY_BUSINESS_NAME(relatedPartyIndex))}
            />
          </FunnelGridUnit>
        )}
        {questions.includes(RELATED_PARTY_QUESTIONS.ADDRESS) && (
          <FunnelGridUnit my="xs" size={1 / 2}>
            <SummaryStringDisplay
              title="Business address"
              value={get(formValues, FIELD_PATHS.RELATED_PARTY_FORMATTED_ADDRESS(relatedPartyIndex))}
            />
          </FunnelGridUnit>
        )}
      </FunnelGrid>
    </Accordion>
  );
};
